import { Edge, Node } from "reactflow";
import { GROUP_NODE_TYPES } from "../constants/endpointValidation.constants";
import { EndpointStatus, EndpointValidationResult } from "../types/endpointValidation.types";

/**
 * Ids of the mapping's endpoints, in node-list order: nodes nothing flows on from. Group
 * containers (farm/process/ingredient gate) are never endpoints -- they have no handles, so edges
 * only ever run between the nodes inside or outside them. Edges pointing at a node that is not in
 * the list are ignored, so a stale edge cannot hide a real endpoint.
 */
export const getEndpointNodeIds = (nodes: Node[], edges: Edge[]): string[] => {
  const presentNodes = (nodes || []).filter(Boolean);
  const nodeIds = new Set(presentNodes.map(node => node.id));
  const sourceIds = new Set(
    (edges || [])
      .filter(edge => edge && nodeIds.has(edge.source) && nodeIds.has(edge.target))
      .map(edge => edge.source)
  );

  return presentNodes
    .filter(node => !GROUP_NODE_TYPES.includes(node.type ?? "") && !sourceIds.has(node.id))
    .map(node => node.id);
};

/** The calculation engine accepts exactly one endpoint per submission; only `"multiple"` blocks. */
export const validateSingleEndpoint = (nodes: Node[], edges: Edge[]): EndpointValidationResult => {
  const endpointIds = getEndpointNodeIds(nodes, edges);
  const status: EndpointStatus =
    endpointIds.length === 0 ? "none" : endpointIds.length === 1 ? "single" : "multiple";

  return { status, endpointIds, blocked: status === "multiple" };
};
